// Встроенные SVG-иконки (одноцветные, currentColor). Имена используются в config/widget.json
// (badges[].icon) и внутри UI. Неизвестное имя → нейтральная точка.
const S = (body, viewBox = "0 0 24 24") =>
  `<svg class="okb-ic" viewBox="${viewBox}" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`;

const ICONS = {
  calendar: S('<rect x="3" y="5" width="18" height="16" rx="3"/><path d="M8 3v4M16 3v4M3 10h18"/>'),
  guest: S('<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>'),
  chevron: S('<path d="M9 6l6 6-6 6"/>'),
  chevronDown: S('<path d="M6 9l6 6 6-6"/>'),
  close: S('<path d="M6 6l12 12M18 6L6 18"/>'),
  paw: S(
    '<circle cx="7" cy="8" r="1.8"/><circle cx="12" cy="6" r="1.8"/><circle cx="17" cy="8" r="1.8"/><path d="M12 11c-3 0-5.5 2.4-5.5 4.8 0 1.5 1.2 2.7 2.7 2.7 1 0 1.9-.5 2.8-.5s1.8.5 2.8.5c1.5 0 2.7-1.2 2.7-2.7C17.5 13.4 15 11 12 11z"/>',
  ),
  child: S('<circle cx="12" cy="7" r="3.5"/><path d="M6 21c.8-3.5 3-5.5 6-5.5s5.2 2 6 5.5"/>'),
  star: `<svg class="okb-ic" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5L2.5 9.4l6.6-.9z"/></svg>`,
  tag: S('<path d="M4 4h7l9 9-7 7-9-9V4z"/><circle cx="8.5" cy="8.5" r="1.4"/>'),
  clock: S('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
  in: S('<path d="M14 4h5v16h-5M3 12h11M10 8l4 4-4 4"/>'),
  out: S('<path d="M10 4H5v16h5M8 12h13M18 8l-4 4 4 4"/>'),
  warn: S('<path d="M12 3l10 18H2L12 3zM12 10v5"/><circle cx="12" cy="18" r=".5"/>'),
  check: S('<circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.7 2.7L16 9.5"/>'),
  dot: `<svg class="okb-ic" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="4"/></svg>`,
};

export const icon = (name) => ICONS[name] ?? ICONS.dot;
